var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.281 15.6562L10.1013 17.8359C9.94454 17.9933 9.75825 18.1181 9.55313 18.2033C9.34801 18.2884 9.1281 18.3323 8.906 18.3323C8.6839 18.3323 8.46399 18.2884 8.25887 18.2033C8.05375 18.1181 7.86746 17.9933 7.71069 17.8359L6.16381 16.2891C6.00649 16.1323 5.88167 15.946 5.79649 15.7409C5.71132 15.5358 5.66748 15.3158 5.66748 15.0938C5.66748 14.8717 5.71132 14.6517 5.79649 14.4466C5.88167 14.2415 6.00649 14.0552 6.16381 13.8984L8.3435 11.7188",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 17.0625L4.6875 19.3125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 4.6875L17.0625 6.9375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8438 13.4062L11.4375 14.8125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 11.1562L9.1875 12.5625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6562 12.2815L17.8359 10.1018C17.9933 9.94502 18.1181 9.75874 18.2033 9.55362C18.2884 9.3485 18.3323 9.12859 18.3323 8.90649C18.3323 8.68439 18.2884 8.46447 18.2033 8.25936C18.1181 8.05424 17.9933 7.86795 17.8359 7.71117L16.2891 6.1643C16.1323 6.00698 15.946 5.88215 15.7409 5.79698C15.5358 5.71181 15.3158 5.66797 15.0938 5.66797C14.8717 5.66797 14.6517 5.71181 14.4466 5.79698C14.2415 5.88215 14.0552 6.00698 13.8984 6.1643L11.7188 8.34399",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 7.78125L16.2188 12.8438",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 11.1562L12.8438 16.2188",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationActive);
export default __webpack_public_path__ + "static/media/integration_active.e6ecc0460a8adc71934f43a66dbf984a.svg";
export { ForwardRef as ReactComponent };